import React, { memo } from 'react'
import Zoom from 'react-medium-image-zoom'

import 'react-medium-image-zoom/dist/styles.css'
import styles from './styles.module.scss'

interface IProps {
  imgUrl: string
}

export const CustomViewZoom: React.FC<IProps> = memo(({ imgUrl }) => {
  return (
    <Zoom zoomMargin={window.innerWidth <= 576 ? 20 : 50}
          classDialog={styles.customViewZoom}
    >
      <div
        role="img"
        style={{
          backgroundColor: 'transparent',
          backgroundImage: `url(${imgUrl})`,
          backgroundPosition: '50%',
          backgroundRepeat: 'no-repeat',
          backgroundSize: 'cover',
          borderRadius: '5px',
          height: '0',
          paddingBottom: '56%',
          width: '100%'
        }}
      />
    </Zoom>
  )
})
